export enum UserFeedbackType {
  PLATFORM = "PLATFORM",
  SERVICE = "SERVICE"
}
